import React, { createContext, useState, useEffect, useCallback } from "react";
import { getAPIURL, setCachedBusiness, getCachedBusiness } from "../lib/utils";
import { withActiveToken } from "../lib/auth";
import { useRouter } from "next/router";

const ToolTipContext = createContext({
  activeTooltip: null,
  setActiveTooltip: () => { },
  nextTooltip: () => { },
  isLastTooltip: false,
  setIsLastTooltip: () => { },
});

export const ToolTipProvider = (props) => {
  const [activeTooltip, setActiveTooltip] = useState(null);
  const [isLastTooltip, setIsLastTooltip] = useState(false);
  const router = useRouter();

  useEffect(() => {
    if (activeTooltip === 2) {
      setIsLastTooltip(true);
    }
  }, [activeTooltip]);
  const nextTooltip = useCallback(() => {
    if (isLastTooltip) {
      setActiveTooltip(null);
    } else {
      setActiveTooltip((prev) => prev + 1);
    }
  }, []);


  const context = {
    activeTooltip,
    setActiveTooltip,
    nextTooltip,
    isLastTooltip,
  };

  return (
    <ToolTipContext.Provider value={context}>
      {props.children}
    </ToolTipContext.Provider>
  );
};

export default ToolTipContext;
